import { Chip } from "@mui/material";

function CatalistOnlyChip({ abbreviated }) {
  const label = abbreviated ? "C" : "Catalist Only";
  return (
    <Chip
      label={label}
      color="contrast"
      size="small"
      sx={{
        "& .MuiChip-label": {
          fontSize: "11px",
        },
        marginLeft: "8px",
      }}
    />
  );
}

export default CatalistOnlyChip;
